import { BaseAction, actionTypes } from 'redux/actions';

export interface ResourcesState {
  lng: string;
  locales: {
    [key: string]: { [key: string]: string; }
  };
  availOptions: { value: string, text: string }[];
};

export interface locale {
  lng: string;
  data: { [key: string]: string; }
}

const initialState: ResourcesState = {
  lng: 'zh',
  locales: {},
  availOptions: [{ value: 'zh', text: '中文' }] // 預設僅中文
};

export const resourcesReducer = (state: ResourcesState = initialState, action: BaseAction) => {
  switch (action.type) {
    case actionTypes.RESOURCES.SET_AVAIL_OPTIONS:
      return { ...state, availOptions: action.payload };
    case actionTypes.RESOURCES.SET_LANGUAGE:
      return { ...state, lng: action.payload };
    case actionTypes.RESOURCES.ADD_LOCALE:
      state.locales[action.payload.lng] = action.payload.data;
      return { ...state };
    default:
      return state;
  }
};
